var map = {
	"./1AGP.png": 16155,
	"./2AGP.png": 10117,
	"./3AGP.png": 77178,
	"components/Catalog/AGP/img/glass/pr/prPlusGold/1AGP.png": 16155,
	"components/Catalog/AGP/img/glass/pr/prPlusGold/2AGP.png": 10117,
	"components/Catalog/AGP/img/glass/pr/prPlusGold/3AGP.png": 77178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3642;